import { cn } from "@/lib/cn";

export function Table({ className, ...props }) {
  return (
    <div className="w-full overflow-x-auto">
      <table
        className={cn("w-full border-collapse text-sm font-sans nums", className)}
        {...props}
      />
    </div>
  );
}

export function THead({ className, ...props }) {
  return <thead className={cn("border-b border-border", className)} {...props} />;
}

export function TBody({ className, ...props }) {
  return <tbody className={className} {...props} />;
}

export function TR({ className, ...props }) {
  return (
    <tr
      className={cn(
        "border-b border-border last:border-0 transition-colors hover:bg-accent/40",
        className
      )}
      {...props}
    />
  );
}

export function TH({ className, ...props }) {
  return (
    <th
      className={cn(
        "px-4 py-2.5 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground",
        className
      )}
      {...props}
    />
  );
}

export function TD({ className, ...props }) {
  return <td className={cn("px-4 py-2.5 text-foreground align-middle", className)} {...props} />;
}
